"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFilters = void 0;
var _types = require("../../types");
var _validateFlatFilters = require("./validateFlatFilters");
var _validateHouseFilters = require("./validateHouseFilters");
var _validateJKFilters = require("./validateJKFilters");
var _validateLandFilters = require("./validateLandFilters");
/* eslint-disable */

/**
 * Санк для валидации фильтров оценки
 * В зависимости от типа оцениваемой недвижимости, будет выбран валидатор
 * Для Квартир выбирается валидатор квартир, для ЖК - соответственно
 * */
const validateFilters = () => async (dispatch, getState) => {
  const {
    filters: {
      estimationTarget
    }
  } = getState();
  switch (estimationTarget) {
    case _types.EEstimationTargets.flat:
      return dispatch((0, _validateFlatFilters.validateFlatFilters)());
    case _types.EEstimationTargets.house:
      return dispatch((0, _validateHouseFilters.validateHouseFilters)());
    case _types.EEstimationTargets.land:
      return dispatch((0, _validateLandFilters.validateLandFilters)());
    case _types.EEstimationTargets.newbuilding:
      return dispatch((0, _validateJKFilters.validateJKFilters)());
  }
};
exports.validateFilters = validateFilters;